// extracted by mini-css-extract-plugin
export default {"wrapper":"FuwEditImage_wrapper__zCan0","cropper":"FuwEditImage_cropper__jc3CG","footer":"FuwEditImage_footer__0ngnc"};